<template>
  <div>
    <component-header
      title="View Customer"
      :hasReload="false"
      :hasSearch="false"
      :hasback="true"
      @back-press="$router.push({ path: '/customers' })"
      :hasCreate="false"
    />
    <b-card>
      <b-row class="mt-3">
        <b-col md="6">
          <p><strong>First Name:</strong> {{ firstName }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Last Name:</strong> {{ lastName }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Email:</strong> {{ email }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Phone:</strong> {{ phone }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Unit:</strong> {{ unit }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Unit Type:</strong> {{ unitType }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Floor:</strong> {{ floor }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Block:</strong> {{ block }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Lease Start:</strong> {{ leaseStart }}</p>
        </b-col>
        <b-col md="6">
          <p><strong>Lease End:</strong> {{ leaseEnd }}</p>
        </b-col>
        <b-col
          md="6"
          v-for="([key, value], index) in Object.entries(extendedData)"
          :key="index"
        >
          <p>
            <strong>{{ camelCaseToTitleCase(key) }} :</strong>
            {{ formatString(value) }}
          </p>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import ComponentHeader from "@/components/componentNewHeader";
import moment from "moment";
import { mapState } from "vuex";

export default {
  components: {
    ComponentHeader,
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      unit: "",
      unitType: "",
      floor: "",
      block: "",
      leaseStart: null,
      leaseEnd: null,
      requestListData: null,
    };
  },
  computed: {
    ...mapState({
      extendedData: (state) => state.onboardCustomer.extendedData,
    }),
  },
  methods: {
    formatString(dateString) {
      // Check if the input is a string and contains common date separators
      const datePattern = /\d{1,2}[/-]\d{1,2}[/-]\d{2,4}/; // Adjust the regex based on expected date formats
      if (typeof dateString === "string" && datePattern.test(dateString)) {
        const date = moment(dateString);

        if (date.isValid()) {
          // Render the date in a desired format, e.g., 'MMMM Do YYYY'
          return date.format("MMMM Do YYYY");
        }
      }
      return dateString; // Return original if not a valid date string
    },

    camelCaseToTitleCase(camelCaseString) {
      const titleCaseString = camelCaseString
        .replace(/([A-Z])/g, " $1") // Add space before uppercase letters
        .replace(/_/g, " "); // Replace underscores with spaces

      return titleCaseString
        .split(" ")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        )
        .join(" ");
    },
    async requestList() {
      const payload = {
        id: this.$route.params.id,
      };
      try {
        const response = await this.$store.dispatch(
          "onboardCustomer/requestList2Action",
          payload
        );
        this.requestListData = response.data;
      } catch (error) {
        console.error("Error fetching request list:", error);
      }
    },
    async getCustomerDetails() {
      await this.$store
        .dispatch("onboardCustomer/customerDetails", this.$route.params.id)
        .then((res) => {
          this.firstName = res?.name?.first;
          this.lastName = res?.name?.last;
          this.email = res?.authentication?.email;
          this.phone = `+91 ${res?.authentication?.phone}`;
          this.unit =
            this.requestListData.response[0].items[0].custom.unitNo || "N/A";
          this.unitType =
            this.requestListData.response[0].items[0].custom.UnitTitle || "N/A";
          this.floor =
            this.requestListData.response[0].items[0].custom.Floor || "N/A";
          this.block =
            this.requestListData.response[0].items[0].custom.Block || "N/A";
          this.leaseStart =
            this.requestListData.response[0].items[0].custom.leaseStart ||
            "N/A";
          this.leaseEnd =
            this.requestListData.response[0].items[0].custom.leaseEnd || "N/A";
        });
    },
  },
  async mounted() {
    await this.requestList();
    this.getCustomerDetails();
  },
};
</script>
